import { createContext, useContext, type ReactNode } from "react";
import { useQuery } from "@tanstack/react-query";
import type { MeResponse } from "@app/shared";
import { api, ApiError } from "../lib/api";

// 認証ユーザーの少量の状態は Context で保持（サーバ状態は TanStack Query・[19] §5）。
interface AuthValue {
  user: MeResponse | null;
  isLoading: boolean;
}
const AuthContext = createContext<AuthValue>({ user: null, isLoading: true });

async function fetchMe(): Promise<MeResponse | null> {
  try {
    return await api.get<MeResponse>("/auth/me");
  } catch (err) {
    if (err instanceof ApiError && err.status === 401) return null;
    throw err;
  }
}

export function AuthProvider({ children }: { children: ReactNode }) {
  const query = useQuery({ queryKey: ["me"], queryFn: fetchMe, staleTime: 60_000, retry: false });
  return (
    <AuthContext.Provider value={{ user: query.data ?? null, isLoading: query.isPending }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
